import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
interface ILanguagesParameters {
  relations?: string[];
  sortBy?: string[];
  extraFilters?: Record<string, string | number>;
  pageSize?: number;
  search?: string;
  fields?: string[];
}
export const useFetchLanguages = (params: ILanguagesParameters) => {
  const fetchLanguages = async ({ pageParam = 1 }) => {
    const { relations: languageRelations, extraFilters: filters, ...rest } = params;
    const queryString = new URLSearchParams(
      Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
    );

    Object.entries(filters ?? {}).forEach(([key, value]) => {
      queryString.append(`filter.${key}`, String(value));
    });

    (languageRelations ?? []).forEach((rel) => queryString.append('relations', rel));
    queryString.append('page', String(pageParam));
    queryString.append('limit', String(params.pageSize));
    try {
      return await get(`${API_URLS.LANGUAGES_LIST}?${queryString.toString()}`);
    } catch (error) {
      console.error('Error fetching languages:', error);
      throw new Error((error as { message: string }).message || 'Failed to fetch languages'); // Force error throwing
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['languages', params],
    queryFn: fetchLanguages,
    getNextPageParam: (lastPage, allPages) => {
      const totalPageCount = lastPage?.meta?.totalItems ?? 0;
      const fetchedPageCount = allPages.flatMap((page) => page.data).length;
      return fetchedPageCount < totalPageCount ? allPages.length + 1 : undefined;
    },
  });
  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  };
};
